// extracted by mini-css-extract-plugin
module.exports = {"hoverActionIcons":"HoverActionsOnRecTestStep_hoverActionIcons__bAOWP","borderRight":"HoverActionsOnRecTestStep_borderRight__2afy1"};